// extracted by mini-css-extract-plugin
export var btn = "F_mB s_sc s_rX d_bz d_bP d_bD d_dw";
export var full = "F_vG d_w d_H";
export var hoverStyle = "F_mF";
export var zoom = "F_mG";